import * as actionTypes from "../constants/actionTypes";

export const updateImportFormat = (format) => ({
    type: actionTypes.CUSTOM_DATA_UPDATE_IMPORT_FORMAT,
    payload: {
        format: format
    }
});

export const importCustomData = (formatName, files, options) => ({
    type: actionTypes.CUSTOM_DATA_IMPORTING_START,
    payload: {
        formatName: formatName,
        files: files,
        options: options
    }
});

export const abortImportingData = () => ({
    type: actionTypes.CUSTOM_DATA_ABORT_IMPORTING
});

export const deleteImportedData = () => ({
    type: actionTypes.CUSTOM_DATA_DELETE_IMPORTED_DATA
});

export const backupLocalDB = (path) => {
    return {
        type: actionTypes.PREPARE_FILE_BACKUP_LOCAL_DB,
        payload: {
            path: path
        }
    };
};

export const downloadLocalFileToPath = (fileId, path) => {
    return {
        type: actionTypes.PREPARE_FILE_LOCAL,
        payload: {
            fileId: fileId,
            path: path
        }
    };
};
